'use client';
import React, { FC } from 'react';
import Slider, { Settings } from 'react-slick';
import { TypeContentCarouselFields, TypeImage } from '@/core/generated-types';
import { Arrow } from '../Carousel/Arrows';
import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';
import { Image } from '@/components/ui/Image';
import { UniversalCta } from '../UniversalCta';

const ContentCarousel: FC<TypeContentCarouselFields> = ({
  backgroundColor,
  slides = [],
  title,
}) => {
  const settings: Settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <Arrow direction={'right'} />,
    prevArrow: <Arrow direction={'left'} />,
  };

  return (
    <div className={`bg-${backgroundColor?.fields?.color} pb-20 md:pt-20`}>
      {title && (
        <Heading
          tag={HeadingTag.H2}
          size={HeadingSize.H2}
          classes="mb-6 md:mb-0"
          align="center"
          text={title}
        />
      )}
      <Slider
        {...settings}
        className="slider-variant-content-carousel mx-auto max-w-[1300px] md:px-16"
      >
        {slides.map((slide) => {
          return (
            <div key={slide.sys.id}>
              <div className="flex flex-col items-center md:flex-row">
                <div className="order-2 -mt-10 w-[calc(100%-80px)] rounded bg-white px-4 pb-8 pt-6 text-center md:order-1 md:mt-0 md:w-[40%] md:bg-transparent md:p-0 md:pr-12 md:text-left lg:pr-28">
                  <div className="mb-4 text-base text-purple md:text-lg">
                    {slide.fields.leadingTitle}
                  </div>
                  <div className="text-2xl font-bold md:text-3xl">
                    {slide.fields.title}
                  </div>
                  <div className="mt-4 text-base">
                    {slide.fields.description}
                  </div>
                  {slide.fields.cta && (
                    <div className="mt-8 flex justify-center md:mt-3 md:justify-start">
                      <UniversalCta
                        link={slide.fields.cta}
                        className="flex-none"
                        defaultButtonStyle="Link"
                      />
                    </div>
                  )}
                </div>
                <div className="order-1 h-[220px] w-full md:order-2 md:h-auto md:w-[60%]">
                  <Image
                    alt={slide.fields?.media?.fields?.altText}
                    className="h-full w-full object-cover"
                    imageData={slide.fields?.media as TypeImage}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default React.memo(ContentCarousel);
